<script>
  export let name
  import { onDestroy, onMount, tick } from "svelte"
  import api from "../services/api"
  import { init } from "../services/users"
  import { navigate } from "svelte-routing"
  import { channels } from "../stores.js"

  import Header from "../components/Header.svelte"
  import ColapsingPanel from "../components/ColapsingPanel.svelte"
  import Light from "../components/Light.svelte"
  import ModalPanel from "../components/ModalPanel.svelte"

  import Status from "../components/Status.svelte"

  let event
  let lights = {}
  let last_update
  let ingestsActive = false
  let ingest
  let states_in_progress = []
  let noControll = false

  function status() {
    api
      .request({ path: `/events/${name}`, credentials: true })
      .then((data) => {
        if (last_update === data.modifiedAt) {
          console.log("skipping refresh - no change")
          return
        }
        last_update = data.modifiedAt
        event = data
        lights = {
          dns: { PENDING: 1, SET: 2 }[event.ns1.state] || 1,
          sg: { IDLE: 1, IN_USE: 2 }[event.mediaLive.securityGroup.state] || 1,
          input: { ATTACHED: 2, DELETED: 0, "N/A": 1 }[
            event.mediaLive.input.state || "N/A"
          ],
          channel: {
            RUNNING: 2,
            STARTING: 1,
            STOPPING: 1,
            CREATING: 1,
            IDLE: 1,
            DELETING: 1,
            DELETED: 0,
            "N/A": 1,
          }[event.mediaLive.channel.state || "N/A"],
          akamai:
            {
              IDLE: 1,
              RUNNING: { OK: 2, NOK: 1 }[event.akamai.state],
              STOPPING: 0,
              CREATING: 0,
              DELETING: 1,
              DELETED: 0,
            }[event.mediaLive.channel.state] ?? 0,
        }
        lights.setup = [lights.dns, lights.sg, lights.input, lights.channel]
          .filter((n) => n !== 0)
          .reduce((p, c) => (c < p ? c : p), 3)
        lights.stream = [lights.akamai]
          .filter((n) => n !== 0)
          .reduce((p, c) => (c < p ? c : p), 3)

        ingest = (($channels || []).filter(
          (ch) => ch.name === data.channelName
        ) || [{}])[0].ingest
        states_in_progress = []
      })
      .catch((err) => {
        console.error(err)
        if (err.response && err.response.status === 404) {
          init().then(navigate("/"))
        }
        event = undefined
      })
  }
  const interval = setInterval(status, 5000)
  onDestroy(() => clearInterval(interval))

  function handleWildMoka(state) {
    event.state = "stopped"
    noControll = true
    api.request({
      path: `/events/${name}/wildmoka/${state}`,
      credentials: true,
      method: "post",
    })
  }
  onMount(async () => {
    await status()
  })
</script>

<Header text="manage event" eventName={name} />

{#if event}
  <ColapsingPanel>
    <div slot="header">
      <div>
        <span class="key">Name:</span>
        <span class="value has-text-weight-bold">{name}</span>
      </div>
    </div>
    <div slot="content">
      <div>
        <span class="key" style="margin-left:20px">Channel:</span>
        <span class="value has-text-weight-bold">{event.channelName}</span>
      </div>
    </div>
  </ColapsingPanel>

  <ColapsingPanel>
    <div slot="header">
      <Light size={20} color={lights.setup} />
      <div class="inline">overall SETUP Status</div>
    </div>
    <div slot="content">
      <Status
        name="DNS"
        status={event.ns1.state}
        color={lights.dns}
        timestamp={event.ns1.last_state_change}
      />
      <Status
        name="MediaLive Security Group"
        status={event.mediaLive.securityGroup.state}
        timestamp={event.mediaLive.securityGroup.last_state_change}
        color={lights.sg}
      />
      <Status
        name="MediaLive Input"
        status={event.mediaLive.input.state}
        timestamp={event.mediaLive.input.last_state_change}
        color={lights.input}
      />
      <Status
        name="MediaLive Channel"
        status={event.mediaLive.channel.state}
        timestamp={event.mediaLive.channel.last_state_change}
        color={lights.channel}
      />
    </div>
  </ColapsingPanel>

  <ColapsingPanel>
    <div slot="header">
      <Light size={20} color={lights.stream} />
      <div class="inline">overall STREAM Status</div>
    </div>
    <div slot="content" color={lights.stream}>
      <Status
        name="Akamai Stream"
        status={event.akamai.state}
        color={lights.akamai}
        timestamp={event.akamai.last_state_change}
      />
    </div>
  </ColapsingPanel>

  <div class="status">
    <div class="overall">
      <label class="has-text-weight-bold inline">Status:</label>
      <p class="has-text-centered">
        {#if event.state !== "stopped"}
          {#if event.mediaLive.channel.state == "RUNNING"}
            {#if event.akamai.state !== "OK"}
              Setup ready, please ingest your <b
                class="clickable underlined"
                on:click={() => (ingestsActive = true)}>stream</b
              > and wait for testing state...
            {:else}
              Setup ready, ingest ok, streaming...
            {/if}
          {:else}
            Your setup is starting, please wait...
          {/if}
        {:else}
          Setup is shutting down... please wait.
        {/if}
      </p>
    </div>
    <div class="control">
      <label class="has-text-weight-bold">Event control:</label>
      <div class="has-text-centered">
        <button
          class="button is-primary startstop"
          class:is-loading={states_in_progress.includes("ended")}
          disabled={noControll || event.state === "stopped"}
          on:click={() => handleWildMoka("stopped")}>STOP</button
        >
      </div>
    </div>
  </div>
{:else}
  <h1>doesn't exists</h1>
{/if}

<ModalPanel active={ingestsActive} onClose={() => (ingestsActive = false)}>
  <span slot="header">Ingest</span>
  <span slot="content">
    <p>Please start your camera or encoder to send a rtmp stream to</p>
    {#if ingest}
      <div class="field">
        <label class="label">URL:</label>
        <p
          class="control has-icons-right"
          on:mouseenter={() => {
            ingest.url_input.focus()
            ingest.url_input.select()
          }}
          on:click={() => document.execCommand("copy")}
        >
          <input
            class="input"
            type="text"
            bind:value={ingest.url}
            bind:this={ingest.url_input}
          />
          <span class="icon is-small is-right clickable">
            <i class="fas fa-copy"></i>
          </span>
        </p>
      </div>
      <div class="field">
        <label class="label">STREAMNAME:</label>
        <p
          class="control has-icons-right"
          on:mouseenter={() => {
            ingest.streamname_input.focus()
            ingest.streamname_input.select()
          }}
          on:click={() => document.execCommand("copy")}
        >
          <input
            class="input"
            type="text"
            bind:value={ingest.streamname}
            bind:this={ingest.streamname_input}
          />
          <span class="icon is-small is-right clickable">
            <i class="fas fa-copy"></i>
          </span>
        </p>
      </div>
    {/if}
  </span>
  <div slot="footer">
    <button
      class="button is-primary"
      on:click={() => {
        ingestsActive = false
      }}>OK</button
    >
  </div>
</ModalPanel>

<style>
  .key {
    width: 80px;
    display: inline-block;
    vertical-align: middle;
  }
  .startstop {
    margin: 1.5%;
    width: 43%;
  }
  .terminate {
    width: 90%;
    margin-bottom: 10px;
  }
  .status {
    border: 1px solid #333;
    margin: 5px;
    padding: 5px;
  }
  .status .key {
    margin-left: 5px;
  }
  .states {
    margin-top: 12px;
  }
  .control {
    margin-top: 12px;
  }
  .inline {
    display: inline-block;
    vertical-align: middle;
  }
  .clickable {
    cursor: pointer;
    text-decoration: underline;
  }
</style>
